import { v2ComponentHandlers } from '../../features/mockHandlers';

export const handlers = [...v2ComponentHandlers];
